import React from 'react';

import { FaFacebookF, FaXTwitter, FaYoutube } from 'react-icons/fa6';
import { FaLinkedinIn } from 'react-icons/fa';
import Link from 'next/link';
const Footer = () => {
  return (
    <footer className="footer ">
      <div className="footer__top">
        <div className="container">
          <div className="footer__top-wrapper">
            <div className="row gy-5 gx-2">
              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="footer__about">
                  <Link href="/" className="footer__about-logo">
                    <img src="/images/logo/logo-dark.svg" alt="Logo" />
                  </Link>
                  <p className="footer__about-moto ">
                    We are ensuring a delightful shopping experience for every
                    customer.
                  </p>
                  <div className="footer__social">
                    <ul className="social">
                      <li className="social__item">
                        <Link
                          href="#"
                          aria-label="Facebook"
                          className="social__link social__link--style2"
                        >
                          <FaFacebookF />
                        </Link>
                      </li>
                      <li className="social__item">
                        <Link
                          href="#"
                          className="social__link social__link--style2"
                          aria-label="social link"
                        >
                          <FaLinkedinIn />
                        </Link>
                      </li>
                      <li className="social__item">
                        <Link
                          href="#"
                          className="social__link social__link--style2"
                          aria-label="social link"
                        >
                          <FaYoutube />
                        </Link>
                      </li>
                      <li className="social__item">
                        <Link
                          href="#"
                          className="social__link social__link--style2"
                          aria-label="social link"
                        >
                          <FaXTwitter />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-md-3 col-sm-6 col-6">
                <div className="footer__links">
                  <div className="footer__links-tittle">
                    <h4>Support</h4>
                  </div>
                  <div className="footer__links-content">
                    <ul className="footer__linklist">
                      <li className="footer__linklist-item">
                        {' '}
                        <Link href="/contact">Help</Link>
                      </li>
                      <li className="footer__linklist-item">
                        {' '}
                        <Link href="/contact">Hotline</Link>
                      </li>
                      <li className="footer__linklist-item">
                        {' '}
                        <Link href="/contact">Contact</Link>{' '}
                      </li>
                      <li className="footer__linklist-item">
                        {' '}
                        <Link href="#">Chat now</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-md-3 col-sm-6 col-6">
                <div className="footer__links">
                  <div className="footer__links-tittle">
                    <h4>Account</h4>
                  </div>
                  <div className="footer__links-content">
                    <ul className="footer__linklist">
                      <li className="footer__linklist-item">
                        {' '}
                        <Link href="/login">Sign In</Link>
                      </li>
                      <li className="footer__linklist-item">
                        {' '}
                        <Link href="/cart">View Cart</Link>
                      </li>
                      <li className="footer__linklist-item">
                        {' '}
                        <Link href="/wishlist">My Wishlist</Link>
                      </li>
                      <li className="footer__linklist-item">
                        {' '}
                        <Link href="/invoice">Shipping Details</Link>{' '}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6 col-sm-6">
                <div className="footer__links">
                  <div className="footer__links-tittle">
                    <h4>Quick Links</h4>
                  </div>
                  <div className="footer__links-content">
                    <ul className="footer__linklist">
                      <li className="footer__linklist-item">
                        {' '}
                        <Link href="#">Customer Support</Link>
                      </li>
                      <li className="footer__linklist-item">
                        {' '}
                        <Link href="#">Delivery Details</Link>
                      </li>
                      <li className="footer__linklist-item">
                        {' '}
                        <Link href="#">Terms &amp; Conditions</Link>{' '}
                      </li>
                      <li className="footer__linklist-item">
                        {' '}
                        <Link href="#">Privacy Policy</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-1 col-md-6 col-sm-6">
                <div className="footer__links">
                  <div className="footer__links-tittle">
                    <h4>Company</h4>
                  </div>
                  <div className="footer__links-content">
                    <ul className="footer__linklist">
                      <li className="footer__linklist-item">
                        <Link href="/flash-sale">Flash Sale</Link>
                      </li>
                      <li className="footer__linklist-item">
                        {' '}
                        <Link href="/blogs">Blogs</Link>
                      </li>
                      <li className="footer__linklist-item">
                        {' '}
                        <Link href="/shop">All Brands</Link>{' '}
                      </li>
                      <li className="footer__linklist-item">
                        {' '}
                        <Link href="#">Coupons</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer__bottom">
        <div className="container">
          <div className="footer__bottom-wrapper">
            <div className="footer__bottom-payment">
              <ul className="payment">
                <li className="payment__item">
                  <img src="/images/payment/1.png" alt="payment method logo" />
                </li>
                <li className="payment__item">
                  <img src="/images/payment/2.png" alt="payment method logo" />
                </li>
                <li className="payment__item">
                  <img src="/images/payment/3.png" alt="payment method logo" />
                </li>
                <li className="payment__item">
                  <img src="/images/payment/4.png" alt="payment method logo" />
                </li>
                <li className="payment__item">
                  <img src="/images/payment/5.png" alt="payment method logo" />
                </li>
              </ul>
            </div>
            <div className="footer__bottom-copyright">
              <p className=" mb-0">
                Copyright© 2025{' '}
                <Link
                  href="https://themeforest.net/user/thetork"
                  target="_blank"
                >
                  thetork
                </Link>
                . All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="footer__shape">
        <span className="footer__shape-item footer__shape-item--1">
          <img src="/images/banner/home1/leaf.png" alt="shape icon" />
        </span>
        <span className="footer__shape-item footer__shape-item--2">
          <img src="/images/banner/home1/tomato.png" alt="shape icon" />
        </span>
        <span className="footer__shape-item footer__shape-item--3">
          <img src="/images/banner/home1/chilli.png" alt="shape icon" />
        </span>
      </div>
    </footer>
  );
};

export default Footer;
